export default __webpack_public_path__ + "static/media/requestPhotoIcon.b5aec35b.svg";